"use strict";

angular.module("login").classy.controller({
    name: "ResetPasswordController",
    inject: ["$scope", "$state", "authServiceFactory", "$location", "$window", "$timeout"],
    init: function() {
        this.$.form = {pass1: "", pass2: ""};
        this.$.resettoken = this.$location.search().token;
        this.$.version = null;

        // Make sure a valid token was passed in
        if (typeof this.$.resettoken !== "string" || this.$.resettoken.length !== 96) {
            return;
        }

        // Get the FAST client version associated with the token
        this.authServiceFactory.getVersion(this.$.resettoken).then((data) => {
            $(".index-loading-area").addClass("hidden");

            if (!data || !data.data || !data.data[0] || !data.data[0].version) {
                this.$.message = "Reset link is not active.";
                this.$.version = 0;
                this.$.loading = true;

                throw new Error(this.$.message);
            }

            this.$.version = data.data[0].version;
            this.$.loading = false;
        });
    },
    reset: function() {
        this.$.loading = true;
        this.$.message = "";
        this.$.form.token = this.$.resettoken;

        return this.authServiceFactory.resetPassword(this.$.form).then((data) => {
            if (data.data.error) {
                if (data.data.error === "badtoken") {
                    this.$.message = "Reset token not found.";
                } else if (data.data.error === "expiredtoken") {
                    this.$.message = "Reset token expired.";
                } else if (data.data.error === "passwordmismatch") {
                    this.$.message = "Passwords do not match.";
                } else if (data.data.error === "passwordinvalid") {
                    this.$.message = "Passwords must be at least 8 characters.";
                } else if (data.data.error === "invaliduser") {
                    this.$.message = "User does not exist.";
                } else if (data.data.error === "multipleaccounts") {
                    this.$.message = "Multiple accounts exist for this user, "
                        + "please contact customer service to reset your password.";
                } else {
                    this.$.message = "Unspecified error, please contact customer service.";
                }
                this.$.loading = false;
            } else if (data.data.success === 1) {
                this.$.message = "Your password has been sucessfully reset.";
                this.$timeout(() => {
                    this.$state.transitionTo("root");
                }, 1000);
            } else {
                this.$.message = "Unspecified error, please contact customer service.";
                this.$.loading = false;
            }
        });
    }
});
